import {Component} from 'react';
import { Button } from 'react-bootstrap';
import InvestmentInformationText from './datasets/investment_type_info_text';
import InvestmentTransactionCard from './investment_transaction_card';
import setInvestmentText from './objects/set_investment_text';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';
import combineTransByInvestName from '../../../pages/Objects/combine_trans_by_invest_name';

class InvestmentInvestTypeDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false, 
            investmentMonthlyLoaded: false,
            moneyBuildInfoArr: InvestmentInformationText,
         
        };
       this.initializeInformation();
    }

    initializeInformation(){
        this.getInformationText();
        this.setHeading();
        this.buyTranSummaryArr = combineTransByInvestName(this.props.investInfo.buyTransArr);
        this.determineTotalGainLoss();
    }

     getInformationText(){
        this.investType = this.props.investInfo.investType;
        const investType = this.investType;
        const informationTextObj = 
                    this.state.moneyBuildInfoArr.find(elem => elem.investType === investType);
        this.informationText = informationTextObj.text;
        this.imageURL = informationTextObj.imageURL;
    }

    setHeading(){
        const investmentTextObj = setInvestmentText(this.props.investInfo.investType);
        this.headingText = investmentTextObj.headingText;
        this.headingTextPlural = this.headingText + "s";
        this.pluralText = investmentTextObj.investTypeText + "s";
    }

   
    determineTotalGainLoss(){
        this.totalGainLossAmt = 0;
        for (let i=0; i<this.props.investInfo.buyTransArr.length; i++){
            const summaryTran = this.props.investInfo.buyTransArr[i];
            const gainLossAmt = +summaryTran.totalCurrentPrice - +summaryTran.totalInitialPrice;
            this.totalGainLossAmt += gainLossAmt;
        }
        this.totalGainLossClass = "text-center";
        if (this.totalGainLossAmt < 0){
            this.totalGainLossClass += " text-danger";
        }
    }

    render() {
        this.investTypeGeneralInfo =  this.buyTranSummaryArr.map((tranSummary, index) =>
            <InvestmentTransactionCard key={index} transInfo={tranSummary} 
                investType={this.investType} summaryPage={true}  />
        );
    
        const defaultImgSrc = "./assets/UnlockedFeatures/" + this.imageURL;
        let colSpanValue = "5";
        if (this.investType === "bond"){
            colSpanValue = "6";
        }

    return <>
            <div>
                 <div className="mt-4 solid-line moneyBuild-text-size"></div>
                 <h4 className="mt-2 text-center">{this.headingText} Performance</h4>
                 <div style={{ overflowX: 'hidden' }}>
                  <div className="row">
                        <div className="col-sm-2 ml-2">
                            <img src={defaultImgSrc} className="card_size_thumbnail_img" alt="logo" />
                        </div>
                        <div className="col-sm-9">
                            <div>{this.informationText}</div>
                        </div>
                    </div>
                    <div className="mt-4">
                    {this.props.investInfo.buyTransArr.length === 0 ?
                        <div className="mt-2 text-left mx-4 invest-type-text">
                            <div className="mt-2">
                                You do not currently own any {this.pluralText} . 
                            </div>
                             <div className="text-right mr-4">
                                <Button variant="primary"
                                     onClick={() => this.props.openBuySellModal(this.investType)}>
                                        Buy {this.headingTextPlural}
                                </Button>
                            </div>
                        </div>
                    :
                        <>
                            <table className="table table-hover table-no-space invest-type-table-text">
                                <tbody>
                                    <tr>
                                        <th className="text-center">Invest Name</th>
                                        {this.investType === "bond"  ?
                                            <th className="text-center">Type</th>
                                        :
                                            null
                                        }
                                        <th className="text-center">Symbol</th>
                                        <th className="text-center">Quantity Owned</th>
                                        <th className="text-center">Initial Value</th>
                                        <th className="text-center">Current Value</th>
                                        <th className="text-center">Gain/Loss Amt</th>
                                    </tr>
                                        {this.investTypeGeneralInfo}
                                    <tr>
                                        <th className="text-left" colSpan={colSpanValue}>Total Gain/Loss</th>
                                        <th className={this.totalGainLossClass}>{doubleToStringMonthly(this.totalGainLossAmt)}</th>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="text-right mr-4">
                                <Button variant="primary"  onClick={() => this.props.openBuySellModal(this.investType)}>
                                    Buy/Sell {this.headingTextPlural}
                                </Button>
                            </div>
                        </>
                        
                }
                </div>
                </div>
            </div>
       
    </>
    }

    

}

export default InvestmentInvestTypeDisplay;